<template>
  <div class="flex flex-col min-h-screen items-center">
    <div class="flex justify-between items-center w-full max-w-[1280px]">
      <div class="ml-4 sm:ml-0">
        <LogoIcon />
      </div>
      <div class="h-12 mt-5 mb-5 mr-4 sm:mr-8">
        <LanguageSwitch />
      </div>
    </div>
    <div class="cookie-settings-container w-full text-center flex-grow px-4 mb-8">
      <!-- Main content area with padding and centered layout -->
      <div class="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-8 space-y-8">
        <!-- Header section with a title and a descriptive paragraph -->
        <header class="text-center">
          <h1 class="text-4xl font-extrabold text-gray-900 mb-2">
            Cookie Settings
          </h1>
          <p class="text-gray-600 leading-relaxed text-lg text-left">
            This website only uses cookies that are "strictly necessary" for website operation. These technologies are essential for ensuring proper website functionality and providing a smooth user experience, and cannot directly identify your personal identity. According to relevant privacy regulations, this type of cookie does not require your additional consent. You can learn about the technologies we use through the following list.
          </p>
        </header>

        <!-- Section for Cookies -->
        <section class="space-y-6">
          <!-- Cookie Table -->
          <div class="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm">
            <div class="overflow-x-auto">
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">
                      Cookie
                    </th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">
                      Domain
                    </th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">
                      Description
                    </th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">
                      Duration
                    </th>
                    <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">
                      Type
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                  <tr class="hover:bg-gray-50">
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-900 text-left">
                      AWSALB
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-left">
                      account.zyxel.com
                    </td>
                    <td class="px-6 py-4 text-sm text-gray-500 max-w-xs text-left">
                      AWSALB is an application load balancer cookie set by Amazon Web Services to map the session to the target.
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      7 days
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Strictly Necessary</span>
                    </td>
                  </tr>
                  <tr class="hover:bg-gray-50">
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-900 text-left">
                      AWSALBCORS
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-left">
                      account.zyxel.com
                    </td>
                    <td class="px-6 py-4 text-sm text-gray-500 max-w-xs text-left">
                      This cookie is managed by Amazon Web Services and is used for load balancing.
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      7 days
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Strictly Necessary</span>
                    </td>
                  </tr>
                  <tr class="hover:bg-gray-50">
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-900 text-left">
                      rc::a
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-left">
                      google.com
                    </td>
                    <td class="px-6 py-4 text-sm text-gray-500 max-w-xs text-left">
                      This cookie is set by the Google recaptcha service to identify bots to protect the website against malicious spam attacks.
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      never
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Strictly Necessary</span>
                    </td>
                  </tr>
                  <tr class="hover:bg-gray-50">
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-900 text-left">
                      rc::c
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-left">
                      google.com
                    </td>
                    <td class="px-6 py-4 text-sm text-gray-500 max-w-xs text-left">
                      This cookie is set by the Google recaptcha service to identify bots to protect the website against malicious spam attacks.
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      session
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Strictly Necessary</span>
                    </td>
                  </tr>
                  <tr class="hover:bg-gray-50">
                    <td class="px-6 py-4 whitespace-nowrap text-sm font-mono text-gray-900 text-left">
                      v3_locale
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-left">
                      account.zyxel.com
                    </td>
                    <td class="px-6 py-4 text-sm text-gray-500 max-w-xs text-left">
                      This v3_locale is used to store the user's preferred language on the website, ensuring that they are presented with content in their chosen language during their visit.
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      never
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Strictly Necessary</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    </div>
    <ZyxelFooter />
  </div>
</template>
<script>
import LogoIcon from '@/components/LogoIcon.vue';
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import ZyxelFooter from "@/components/ZyxelFooter.vue";

export default {
    name: 'CookieSetting',
    components: {
        LogoIcon,
        LanguageSwitch,
        ZyxelFooter
    },
}
</script>